import React from 'react';
import { Card } from 'antd';
import { Brain, BarChart3, FileText } from 'lucide-react';
import { CallLog } from '@/types/TInbox';

interface SmartCallAnalysisTabProps {
	callData: CallLog;
	postCallAnalysis?: Array<{ label: string; output: string }>;
}

const SmartCallAnalysisTab: React.FC<SmartCallAnalysisTabProps> = ({ postCallAnalysis }) => {
	return (
		<div className="space-y-6">
			<div className="flex items-center gap-2 mb-6">
				<BarChart3 className="w-6 h-6" />
				<h3 className="text-xl font-semibold">Post-Call Analysis Report</h3>
			</div>

			{/* Post-Call Analysis Report */}
			{postCallAnalysis && postCallAnalysis.length > 0 ? (
				<Card className="shadow-sm">
					<div className="flex items-center gap-2 mb-6">
						<Brain className="w-5 h-5 text-blue-600" />
						<h4 className="text-lg font-semibold text-gray-900">Analysis Results</h4>
					</div>

					<div className="space-y-4">
						{postCallAnalysis.map((report, index) => (
							<div
								key={index}
								className="border-l-4 border-blue-500 bg-gradient-to-r from-blue-50 to-blue-25 p-4 rounded-r-lg"
							>
								<div className="mb-3">
									<h5 className="text-base font-semibold text-blue-900 flex items-center gap-2">
										<FileText className="w-4 h-4" />
										{report.label}
									</h5>
								</div>
								<div className="bg-white p-4 rounded-lg border border-blue-100 shadow-sm">
									<p className="text-gray-800 leading-relaxed whitespace-pre-wrap text-sm">
										{report.output}
									</p>
								</div>
							</div>
						))}
					</div>
				</Card>
			) : (
				<Card className="text-center py-12">
					<div className="flex flex-col items-center gap-4">
						<div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
							<BarChart3 className="w-8 h-8 text-gray-400" />
						</div>
						<div>
							<h4 className="text-lg font-medium text-gray-900 mb-2">No Analysis Available</h4>
							<p className="text-gray-500 text-sm">
								Post-call analysis has not been generated for this call yet.
							</p>
						</div>
					</div>
				</Card>
			)}
		</div>
	);
};

export default SmartCallAnalysisTab;
